"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpTabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DpTabs_styled_1 = require("./DpTabs.styled");
var api_1 = require("../../../api");
var DpTabs = function (_a) {
    var tabElements = _a.tabElements, selectTabHandler = _a.selectTabHandler;
    var itemRef = (0, react_1.useRef)();
    (0, api_1.useTabFocus)(tabElements.length, itemRef);
    return ((0, jsx_runtime_1.jsx)(DpTabs_styled_1.StyledDpTabs, { role: "tablist", className: "tablist border-bottom", ref: itemRef, children: tabElements.map(function (tabElement, index) { return ((0, jsx_runtime_1.jsx)("button", { ref: tabElement.tabRef || null, role: "tab", "aria-selected": tabElement.active, "aria-controls": tabElement.customAriaControl || "panel-".concat(index), "data-index": index, tabIndex: tabElement.active ? 0 : -1, className: "btn-tab ".concat(tabElement.active ? 'active' : ''), onClick: function (e) {
                selectTabHandler(tabElement, e);
            }, children: tabElement.label }, tabElement.id)); }) }));
};
exports.DpTabs = DpTabs;
exports.default = exports.DpTabs;
